import script from "./About.vue?vue&type=script&setup=true&lang=js"
export * from "./About.vue?vue&type=script&setup=true&lang=js"

import "./About.vue?vue&type=style&index=0&id=014229d8&lang=css"
import "./About.vue?vue&type=style&index=1&id=014229d8&scoped=true&lang=css"

import exportComponent from "/home/nicolas-choquet/www/play-private-store/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-014229d8"]])

export default __exports__